const FinalizarAvisosVencimentoContrato = () =>
    import('./FinalizarAvisosVencimentoContrato.vue')
const FinalizarAvisosSaldoContrato = () =>
    import('./FinalizarAvisosSaldoContrato.vue')
const FinalizarAvisosSaldoFaseContrato = () =>
    import('./FinalizarAvisosSaldoFaseContrato.vue')
const FinalizarAvisosContratoSemMovimentacao = () =>
    import('./FinalizarAvisosContratoSemMovimentacao.vue')
const FinalizarAvisosComprometimentoSemRegistroPagamento = () =>
    import('./FinalizarAvisosComprometimentoSemRegistroPagamento.vue')
const FinalizarAvisosVencimentoFaseContrato = () =>
    import('./FinalizarAvisosVencimentoFaseContrato.vue')
    

export default {
    path: 'processos',
    name: 'Processos',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'finalizaravisosvencimentocontrato',
            name: 'FinalizarAvisosVencimentoContrato',
            component: FinalizarAvisosVencimentoContrato,
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: 'finalizaravisossaldocontrato',
            name: 'FinalizarAvisosSaldoContrato',
            component: FinalizarAvisosSaldoContrato,
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: 'finalizaravisossaldofasecontrato',
            name: 'FinalizarAvisosSaldoFaseContrato',
            component: FinalizarAvisosSaldoFaseContrato,
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: 'finalizaravisoscontratosemmovimentacao',
            name: 'FinalizarAvisosContratoSemMovimentacao',
            component: FinalizarAvisosContratoSemMovimentacao,
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: 'finalizaravisoscomprometimentosemregistropagamento',
            name: 'FinalizarAvisosComprometimentoSemRegistroPagamento',
            component: FinalizarAvisosComprometimentoSemRegistroPagamento,
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: 'finalizaravisosvencimentofasecontrato',
            name: 'FinalizarAvisosVencimentoFaseContrato',
            component: FinalizarAvisosVencimentoFaseContrato,
            beforeEnter: (to, from, next) => {
                next()
            }
        }
    ]
}
